import { compose } from "redux"
import CatalystPage from "../components/catalyst-page"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import {withTranslations} from "../decorators/with-translations"
import {QUESTIONNAIRE_FRAGMENT} from "../graphql/fragments";

const query = gql`
  query CatalystPage($languageCode: String) {
    questionnaire(languageCode: $languageCode) {
        ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

export default compose(
  withTranslations,
  withData(query, {
      options: props => ({
          ...getVariables(props),
          fetchPolicy: 'cache-first'
      })
  })
)(CatalystPage)



// WEBPACK FOOTER //
// ./src/containers/catalyst-page.js